import { axiosPrivate } from "./axios";

/**
 * HR Form Service
 * Fetches approved request data formatted for HR export
 */

const hrFormService = {
  /**
   * Get HR Form data for a specific week
   * @param {String} weekStart - Optional week start date (YYYY-MM-DD)
   * @returns {Promise} API response with HR form data
   */
  getHRFormData: async (weekStart = null) => {
    const params = weekStart ? { weekStart } : {};
    const response = await axiosPrivate.get("/api/hr-form", { params });
    return response.data;
  },

  /**
   * Mark a week as exported (lock it from modification)
   * @param {String} weekStart - Week start date (YYYY-MM-DD)
   * @returns {Promise} API response
   */
  exportWeek: async (weekStart) => {
    const response = await axiosPrivate.post("/api/hr-form/export", {
      weekStart,
    });
    return response.data;
  },

  /**
   * Check if a week is exported
   * @param {String} weekStart - Week start date (YYYY-MM-DD)
   * @returns {Promise} API response with isExported boolean
   */
  checkWeekExported: async (weekStart) => {
    const response = await axiosPrivate.get("/api/hr-form/export/check", {
      params: { weekStart },
    });
    return response.data;
  },

  /**
   * Update week status (OPEN/CLOSED) - Admin only
   * @param {String} weekStart - Week start date (YYYY-MM-DD)
   * @param {String} status - Week status ("OPEN" or "CLOSED")
   * @returns {Promise} API response
   */
  updateWeekStatus: async (weekStart, status) => {
    const response = await axiosPrivate.post("/api/hr-form/week-status", {
      weekStart,
      status,
    });
    return response.data;
  },

  /**
   * Email the HR form (text + Excel attachment) to HR
   * @param {Object} payload - { label, headers, rows, fileName, fileBase64 }
   */
  sendHRFormEmail: async (payload) => {
    const response = await axiosPrivate.post("/api/hr-form/send-email", payload);
    return response.data;
  },

  getMailSettings: async () => (await axiosPrivate.get("/api/hr-form/mail-settings")).data.data,

  /** @param {{to: string[], cc: string[], bcc: string[]}} settings */
  updateMailSettings: async (settings) =>
    (await axiosPrivate.put("/api/hr-form/mail-settings", settings)).data.data,

  /**
   * Get all exported weeks
   * @returns {Promise} API response with list of exported weeks
   */
  getExportedWeeks: async () => {
    const response = await axiosPrivate.get("/api/hr-form/exports");
    return response.data;
  },
};

export default hrFormService;
